<template>
	<div class="row">
		<div class="col-12">
			<p class="question-text text-center fs-1-2" v-html="questionItem.questionText"></p>
		</div>
		<div class="col-12">
			<div class="row">
				<div class="col-12" v-if="questionItem.questionList.A">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-a" class="checkbox-custom-v" name="chk-a" type="checkbox" v-model="choice.A" @change.prevent="cangeSelected('A')">
						<label for="chk-a" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.A}">{{questionItem.questionList.A}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.B">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-b" class="checkbox-custom-v" name="chk-b" type="checkbox" v-model="choice.B" @change.prevent="cangeSelected('B')">
						<label for="chk-b" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.B}">{{questionItem.questionList.B}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.C">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-c" class="checkbox-custom-v" name="chk-c" type="checkbox" v-model="choice.C" @change.prevent="cangeSelected('C')">
						<label for="chk-c" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.C}">{{questionItem.questionList.C}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.D">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-d" class="checkbox-custom-v" name="chk-d" type="checkbox" v-model="choice.D" @change.prevent="cangeSelected('D')">
						<label for="chk-d" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.D}">{{questionItem.questionList.D}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.E">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-e" class="checkbox-custom-v" name="chk-e" type="checkbox" v-model="choice.E" @change.prevent="cangeSelected('E')">
						<label for="chk-e" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.E}">{{questionItem.questionList.E}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.F">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-f" class="checkbox-custom-v" name="chk-f" type="checkbox" v-model="choice.F" @change.prevent="cangeSelected('F')">
						<label for="chk-f" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.F}">{{questionItem.questionList.F}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.G">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-g" class="checkbox-custom-v" name="chk-g" type="checkbox" v-model="choice.G" @change.prevent="cangeSelected('G')">
						<label for="chk-g" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.G}">{{questionItem.questionList.G}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.H">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-h" class="checkbox-custom-v" name="chk-h" type="checkbox" v-model="choice.H" @change.prevent="cangeSelected('H')">
						<label for="chk-h" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.H}">{{questionItem.questionList.H}}</span>
						</label>
					</div>
				</div>
				<div class="col-12" v-if="questionItem.questionList.I">
					<div class="form-group custom-form-check mt-1 mb-0 d-inline-block">
						<input id="chk-i" class="checkbox-custom-v" name="chk-i" type="checkbox" v-model="choice.I" @change.prevent="cangeSelected('I')">
						<label for="chk-i" class="checkbox-custom-v-label xsmall-text">
							<span class="bold" :class="{'color-selected': choice.I}">{{questionItem.questionList.I}}</span>
						</label>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AbcdComponent',

	props: {
		questionItem: {
			type: Object,
			default: function () {
				return {}
			}
		}
	},

	data() {
		return {
			choice: {
				A: false,
				B: false,
				C: false,
				D: false,
				E: false,
				F: false,
				G: false,
				H: false,
				I: false
			}
		}
	},

	methods: {
		cangeSelected(k) {
			Object.keys(this.choice).forEach(key => {
				if(key != k) {
					this.choice[key] = false
				}
			})
			this.chekValues()
		},

		chekValues() {
			let data = {
				btnNext: false,
				value: ''
			}
			Object.keys(this.choice).forEach(key => {
				if(this.choice[key]) {
					data = {
						btnNext: true,
						value: key
					}
				}
			})
			this.$emit('setAnswerValue', data)
		}
	}
}
</script>

<style scoped>
.checkbox-custom-v {
	opacity: 0;
	position: absolute;
}
.checkbox-custom-v, .checkbox-custom-v-label {
	display: inline-block;
	vertical-align: middle;
	margin: 0;
	cursor: pointer;
	line-height: .9;
}
.checkbox-custom-v-label {
	position: relative;
}
.checkbox-custom-v + .checkbox-custom-v-label:before {
	content: '';
	background: #fff;
	border: 2px solid #000;
	border-radius: 50%;
	display: inline-block;
	vertical-align: middle;
	font-size: 1rem;
	width: 25px;
	height: 25px;
	padding: 2px;
	margin-right: 6px;
	margin-bottom: 1.2em;
	text-align: center;
	float: left;
}
.checkbox-custom-v:checked + .checkbox-custom-v-label:before {
	background: #fff;
	content: '\f00c';
	font-family: 'Font Awesome 5 Free';
    font-size: 1rem;
    line-height: 1;
	font-weight: 700;
	color: #00723D;
	border: 2px solid #00723D;
}
.checkbox-custom-v:focus + .checkbox-custom-v-label {
  outline: 1px solid #ddd; /* focus style */
}
label, .checkbox-custom-v-label {
  outline: 0 !important;
}
.checkbox-custom-v-label span {
	line-height: 25px;
}
.color-selected {
	color: #00723D;
}
</style>
